module.exports = __webpack_public_path__ + "static/explan.b23af9ff.png";